<div id="tendance-marche-immobilier-form" class="px-4">
  <div class="mb-4">
    <div class="mb-3 fw-bold">Courbe de l'indice Insee</div>
    <div class="d-flex ms-4 fs-6">
      <span [ngClass]="{ 'text-black-50': newTendencies.inseeGraph }">
        Désactivé
      </span>
      <p-radio
        title="Courbe de l'indice Insee"
        class="ms-2"
        [checked]="newTendencies.inseeGraph"
        [alwaysActivated]="true"
        (switched)="onInseeGraphSwitched($event)"
      ></p-radio>
      <span [ngClass]="{ 'text-black-50': !newTendencies.inseeGraph }">
        Activé
      </span>
    </div>
  </div>

  <div class="mb-4">
    <div class="mb-3 fw-bold">Etude de marché</div>
    <div class="d-flex ms-4 fs-6">
      <span
        [ngClass]="{ 'text-black-50': newTendencies.marketStudy }"
      >
        Désactivé
      </span>
      <p-radio
        title="Etude de marché"
        class="ms-2"
        [checked]="newTendencies.marketStudy"
        [alwaysActivated]="true"
        (switched)="onMarketStudySwitched($event)"
      ></p-radio>
      <span
        [ngClass]="{ 'text-black-50': !newTendencies.marketStudy }"
      >
        Activé
      </span>
    </div>
  </div>

  <ng-container *ngIf="newTendencies.marketStudy">
    <p class="text-secondary">
      Par défaut le niveau niveau géographique de restitution pour l'étude de marché sera le plus proche et défini en fonction
      des volumes de ventes disponibles sur le secteur : le quartier / la commune / l'EPCI / le département.<br>
      Si vous souhaitez un niveau géographique spécifique (en fonction de la disponibilité des données), merci de le préciser ci-dessous :
    </p>

    <div class="ms-4 mb-4" style="max-width: 320px">
      <p-select
        id="market-study-scope"
        label="Niveau géographique"
        [items]="scopeSelectItems"
        [selectedItem]="scopeItem"
        (selected)="onScopeSelected($event)"
      ></p-select>
    </div>
  </ng-container>

</div>
